import { render } from "./PendientesView.vue?vue&type=template&id=f054daa6"
import script from "./PendientesView.vue?vue&type=script&lang=js"
export * from "./PendientesView.vue?vue&type=script&lang=js"

import "./PendientesView.vue?vue&type=style&index=0&id=f054daa6&lang=css"

import exportComponent from "D:\\laragon\\www\\balkum-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__